export default __webpack_public_path__ + "e4caa97ccdb7a9812a4915726f4794c1.svg";